import { get, isNil } from 'lodash';

import machineBoxIcon from 'resources/images/icon-machina-outlined.svg';

import overview from 'resources/images/sideBarMenu/overview.svg';
import overviewActive from 'resources/images/sideBarMenu/overview-active.svg';

import engine from 'resources/images/sideBarMenu/engine.svg';
import engineActive from 'resources/images/sideBarMenu/engine-active.svg';

import application from 'resources/images/sideBarMenu/application.svg';
import applicationActive from 'resources/images/sideBarMenu/application-active.svg';

import automateStudioIcon from 'resources/images/sideBarMenu/automate_studio_icon.svg';

import schema from 'resources/images/sideBarMenu/schema.svg';
import schemaActive from 'resources/images/sideBarMenu/schema-active.svg';

import graphql from 'resources/images/sideBarMenu/graphql.svg';
import graphqlActive from 'resources/images/sideBarMenu/graphql-active.svg';

const automatePageUri = get(
  window.config,
  'pageUris.automatePageUri',
  'https://automate.veritone.com'
);

const sitemap = (env) => [
  {
    label: 'Overview',
    icon: overview,
    iconActive: overviewActive,
    link: 'overview',
  },
  {
    label: 'Engines',
    icon: engine,
    iconActive: engineActive,
    link: 'engines',
  },
  {
    label: 'Applications',
    icon: application,
    iconActive: applicationActive,
    link: 'applications',
  },
  {
    label: 'Automate Studio',
    icon: automateStudioIcon,
    iconActive: automateStudioIcon,
    link: automatePageUri,
  },
  {
    label: 'Schema',
    link: 'data-schemas',
    icon: schema,
    iconActive: schemaActive,
  },
  {
    label: 'Machine Box',
    icon: machineBoxIcon,
    iconActive: machineBoxIcon,
    link: 'machinebox',
    removeFromAnywhere: true,
  },
  {
    label: 'GraphQL Playground',
    icon: graphql,
    iconActive: graphqlActive,
    link: `${
      isNil(window.config.apiRoot)
        ? window.location.origin
        : window.config.apiRoot
    }/v3/graphql`,
  },
];

export default sitemap;



// WEBPACK FOOTER //
// ./src/client/plugins/app/site-map.js